import React, { useMemo } from 'react';

import { Select } from '@uikit';

import { useMagicWallCategoriesQuery } from '@query';

import { extraFilters } from './constants';

type Props = {
  categoryFilter: string;
  setCategoryFilter: (value: string) => void;
};

// Note: Need to remove it on the backend side in this task
// TODO: Remove this
const keysToExclude = ['CASHBACK', 'FREE_TO_JOIN', 'EXCLUSIVE'];

const CategoryFilter = ({ categoryFilter, setCategoryFilter }: Props) => {
  const query = useMagicWallCategoriesQuery();

  const allCategories = useMemo(() => {
    const filters = query.data?.data.flatMap((page) => page ?? []) ?? [];
    const uniqueCategories = new Set([extraFilters, ...filters]);

    return [...uniqueCategories].filter((item) => !keysToExclude.includes(item.attributes.key));
  }, [query.data]);

  const selectOptions = useMemo(
    () =>
      allCategories.map((category) => ({ value: category.id, label: category.attributes.name })),
    [query],
  );

  const activeCategorySelectOption = useMemo(
    () => selectOptions.find((option) => option.value === Number(categoryFilter)),
    [selectOptions, categoryFilter],
  );

  return (
    <div className="flex gap-4 items-center w-full lg:max-w-[280px]">
      <span className="font-medium flex-shrink-0 max-sm:basis-20">Filter By:</span>

      <Select
        className="min-w-[180px] w-full"
        value={activeCategorySelectOption}
        shape="pill"
        isSearchable={false}
        onChange={(value) => setCategoryFilter((value as any)?.value || null)}
        options={selectOptions}
      />
    </div>
  );
};

export default CategoryFilter;
